import styled from 'styled-components';
import colors from '../../../lib/Colors';
import fonts from '../../../lib/Fonts';

const ResetPasswordFormLabel = styled.h2`
  font-size: 1.75em;
  color: ${colors.almostBlack};
  font-family: ${fonts.family.workSans};
  margin: 0 0 1em;
  font-weight: 300;`;

const ResetPasswordFormMessage = styled.p`
  font-family: ${fonts.family.workSans};
  font-size: 1em;
  line-height: 1.4;
  color: ${colors.colorDefaultheaderText};
`;

export {ResetPasswordFormLabel, ResetPasswordFormMessage};
